import React from "react";
import "./ScreenshotModal.css";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import ReactCrop from "react-image-crop";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import {
  getPageImagesScreenshot,
  addPageImagesScreenshot
} from "../../api/pages";

class ScreenshotModal extends React.Component {
  constructor(props) {
    super(props);
    this.onCropChange = this.onCropChange.bind(this);
    this.nextPressed = this.nextPressed.bind(this);
    this.processCrop = this.processCrop.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.save = this.save.bind(this);
    this.pagingBtnRefs = {};
    this.scrollPageBtns = this.scrollPageBtns.bind(this);
    this.handleCloseCreateModal = this.handleCloseCreateModal.bind(this);

    this.state = {
      step: 0,
      isProcessing: false,
      selectedPage:
        props.leftPage > props.rightPage ? props.leftPage : props.rightPage,
      crop: null,
      percentCrop: null,
      croppedImg: null,
      width: -1,
      height: -1
    };
  }

  componentDidMount() {
    this.scrollPageBtns();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedPage !== this.state.selectedPage) {
      this.scrollPageBtns();
    }
  }

  scrollPageBtns() {
    if (this.pagingBtnRefs[this.state.selectedPage] != null) {
      this.pagingBtnRefs[this.state.selectedPage].scrollIntoView({
        behavior: "auto"
      });
    }
  }

  onImageLoaded(image) {
    this.setState({ width: image.naturalWidth, height: image.naturalHeight });
    return false;
  }

  async processCrop() {
    const { issue } = this.props;
    const { selectedPage, percentCrop, width, height } = this.state;

    if (width < 0 || height < 0) {
      toast.error("img not load");
      return;
    }

    if (percentCrop == null) {
      toast.error("no crop");
      return;
    }

    const cropWidthPercent = percentCrop.width;
    const cropHeightPercent = percentCrop.height;

    if (cropWidthPercent <= 0 || cropHeightPercent <= 0) {
      toast.error("no crop");
      return;
    }

    const cropXPercent = percentCrop.x;
    const cropYPercent = percentCrop.y;

    const pageID = issue.pages[selectedPage - 1].id;

    if (pageID == null) {
      toast.error("page id null");
      return;
    }

    this.setState({ isProcessing: true });

    try {
      const realX = Math.floor((cropXPercent * width) / 100);
      const realY = Math.floor((cropYPercent * height) / 100);
      const realWidth = Math.floor((cropWidthPercent * width) / 100);
      const realHeight = Math.floor((cropHeightPercent * height) / 100);

      let image = await getPageImagesScreenshot(
        pageID,
        realX,
        realY,
        realWidth,
        realHeight
      );

      this.realX = realX;
      this.realY = realY;
      this.realW = realWidth;
      this.realH = realHeight;

      this.setState({
        croppedImg: "data:image/jpeg;base64," + image.data,
        isProcessing: false,
        step: 1
      });
    } catch (e) {
      toast.error(e.toString());
      this.setState({ isProcessing: false, step: 0 });
    }
  }

  async save() {
    const { issue } = this.props;
    const { selectedPage } = this.state;

    const pageID = issue.pages[selectedPage - 1].id;

    if (
      this.realX == null ||
      this.realY == null ||
      this.realW == null ||
      this.realH == null
    ) {
      toast.error("x y w h error");
      return;
    }

    this.setState({ isProcessing: true });

    try {
      await addPageImagesScreenshot(
        pageID,
        this.realX,
        this.realY,
        this.realW,
        this.realH
      );
      this.setState({
        isProcessing: false,
        step: 0,
        crop: null,
        percentCrop: null,
        croppedImg: null
      });
      this.props.handleReload();
    } catch (e) {
      toast.error(e.toString());
      this.setState({ isProcessing: false });
    }
  }

  nextPressed() {
    const { step } = this.state;

    if (step <= 0) {
      this.processCrop();
    } else {
      this.save();
    }
  }

  onCropChange(crop, percentCrop) {
    this.setState({ crop, percentCrop });
  }

  handleCloseCreateModal() {
    if (this.state.step > 0) {
      this.setState({ step: this.state.step - 1 });
      return;
    }

    this.setState({
      step: 0,
      isProcessing: false,
      selectedPage: this.props.article.first_page,
      crop: null
    });

    this.props.handleCloseModal(false);
  }

  pageClicked(page) {
    this.setState({ selectedPage: page });
  }

  renderStep0() {
    const { pageArr, issue } = this.props;
    const { selectedPage, crop } = this.state;

    return (
      <React.Fragment>
        <Row>
          <ReactCrop
            imageStyle={{ maxHeight: "none" }}
            disabled={this.state.isProcessing}
            className="screenshot_image"
            crop={crop}
            onImageLoaded={this.onImageLoaded}
            onChange={this.onCropChange}
            src={`${process.env.REACT_APP_API_ROOT}pages/${
              issue.pages[selectedPage - 1].id
            }/page_image`}
          />
        </Row>
        <Row>
          <Col style={{ textAlign: "center" }}>
            <ButtonGroup
              className="article_paging_btns article_page_num_btns"
              variant="info"
            >
              {pageArr.map(page => (
                <Button
                  disabled={this.state.isProcessing}
                  key={page}
                  ref={ref => (this.pagingBtnRefs[page] = ref)}
                  variant={page === selectedPage ? "dark" : "secondary"}
                  className="toc_paging_btn"
                  onClick={() => this.pageClicked(page)}
                >
                  {page}
                </Button>
              ))}
            </ButtonGroup>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  renderStep1() {
    return (
      <Row>
        <Image className="screenshot_image" src={this.state.croppedImg} />
      </Row>
    );
  }

  render() {
    const { step } = this.state;

    return (
      <Modal
        size="lg"
        backdrop="static"
        show={this.props.showCreateModal}
        onHide={this.handleCloseCreateModal}
        centered
      >
        <Modal.Body>
          <Container>
            {step <= 0 ? this.renderStep0() : this.renderStep1()}
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.handleCloseCreateModal}
            disabled={this.state.isProcessing}
          >
            {step <= 0 ? "Close" : "Back"}
          </Button>
          <Button
            onClick={this.nextPressed}
            variant="info"
            disabled={this.state.isProcessing}
          >
            {step <= 0 ? "Crop" : "Create"}
          </Button>
          <div className="spinner_container">
            {" "}
            {this.state.isProcessing && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ScreenshotModal;
